import { GET, POST, PUT } from "./common/http";
import { BASE_URL } from "./common/const";

export const CreateStakemap = (data: any) =>
  POST(`${BASE_URL}/stakemap/create`, data);

export const UpdateStakemap = (data: any) =>
  PUT(`${BASE_URL}/stakemap/update`, data);

export const UpdateStakemapAccessed = (data: any) =>
  PUT(`${BASE_URL}/stakemap/updateaccessed`, data);

export const GetStakemapDetail = (params: any) =>
  GET(`${BASE_URL}/stakemap/detail?` + params, null);

export const GetStakemapList = (params: any) =>
  GET(`${BASE_URL}/stakemap/list?` + params, null);
